import type { ReactNode } from "react";
import { useLanguage } from "@mmm/ui";
/**
 * Standard header for the top-level pages (Home, Tasks, Calendar, Subjects):
 * today's date as an eyebrow line above the title. One shared block so every
 * global page has the same header structure and title position.
 */
export function PageTitle({ title }: { title: string }) {
  return (
    <>
      <PageDateLine />
      <h1 className="mmm-page-title">{title}</h1>
    </>
  );
}

export function PageDateLine({ children }: { children?: ReactNode }) {
  const { language } = useLanguage();
  return (
    <p className="mmm-page-eyebrow">
      {new Date().toLocaleDateString(language, { weekday: "long", month: "long", day: "numeric" })}
      {children}
    </p>
  );
}
